import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * IMPORTANT:
 * Popow는 커스텀 typography 토큰(예: `text-body-1-reading-regular`)과
 * semantic/atomic 색상 토큰(예: `text-semantic-label-strong`)을 함께 사용합니다.
 *
 * `tailwind-merge` 기본 동작은 `text-*` 프리픽스를 같은 그룹으로 오판하여
 * font-size 또는 color 중 하나를 제거할 수 있습니다.
 *
 * Fix:
 * - typography 토큰은 `font-size` 그룹으로 분리
 * - semantic/atomic 색상 토큰은 `text-color` / `bg-color` / `border-color`로 분리
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom typography tokens (fontSize keys in tailwind.config.js)
      'font-size': [
        {
          text: [
            (value: string) =>
              value.startsWith('display-') ||
              value.startsWith('title-') ||
              value.startsWith('heading-') ||
              value.startsWith('headline-') ||
              value.startsWith('body-') ||
              value.startsWith('label-') ||
              value.startsWith('caption-'),
          ],
        },
      ],
      // Custom color tokens (semantic/atomic)
      'text-color': [
        { text: [(value: string) => value.startsWith('semantic-') || value.startsWith('atomic-')] },
      ],
      'bg-color': [
        { bg: [(value: string) => value.startsWith('semantic-') || value.startsWith('atomic-')] },
      ],
      'border-color': [
        {
          border: [(value: string) => value.startsWith('semantic-') || value.startsWith('atomic-')],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
